<template>
  <div>
    <v-toolbar app
               :color="savingsColor"
               extended
               extension-height="20"
               class="mt-2 white--text">
      <v-layout column>
        <v-flex class="font-italic">Annual Savings</v-flex>
        <v-flex>
          <h1>{{annualTotal | currency}}</h1>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <h4>{{totalByHeads | currency}} / head</h4>
      <v-layout row slot="extension">
        <v-flex class="font-italic ">Save {{slider | currency}}/mile,</v-flex>
        <v-flex class="font-italic justify-end">{{effectiveRate | currency}}/mile adjusted rate</v-flex>
      </v-layout>
    </v-toolbar>

    <v-container class="pa-0" align-center text-xs-center>
      <v-layout column wrap>

        <v-flex xs12 >
          <v-card>
            <v-card-text>
              <v-layout row>
                <v-flex class="pr-1">
                  <v-text-field label="Head Count"
                                v-model.number="headsCount"
                                type="number">
                  </v-text-field>
                  <v-select
                    :items="weightOptions"
                    v-model.number="weight"
                    label="Avg. Per-head Weight">
                  </v-select>
                  <v-text-field label="Avg. Distance in miles"
                                v-model.number="distance"
                                type="number">
                  </v-text-field>
                </v-flex>
                <v-flex class="pl-1">
                  <v-select
                    :items="freqOptions"
                    item-text="name"
                    item-value="value"
                    v-model="selectedFreq"
                    :error="selectedFreq == null"
                    :label="frequencyLabel">
                  </v-select>
                  <v-select
                    :items="truckCapacityOptions"
                    item-text="name"
                    item-value="value"
                    v-model="truckCapacityPounds"
                    label="Avg. Truck Capacity">
                  </v-select>

                  <v-text-field label="Current Per-mile Rate"
                                v-model.number="standardRate"
                                type="number">
                  </v-text-field>

                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md12 class="pt-2 pb-1">
          <v-card>
            <v-layout row>
              <v-flex >
                <h4 class="font-italic font-weight-thin">{{truckCapacityAnimalCount}}</h4>
              </v-flex>
              <v-flex >
                <h4 class="font-italic font-weight-thin">animals per load</h4>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex >
                <h4 class="font-italic font-weight-thin">{{truckCount}}</h4>
              </v-flex>
              <v-flex >
                <h4 class="font-italic font-weight-thin">trucks ({{annualTruckCount}} annually)</h4>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex >
                <h4 class="font-italic  green--text">{{(slider * distance) | currency}}</h4>
              </v-flex>
              <v-flex >
                <h4 class="font-italic font-weight-thin">per load freight savings</h4>
              </v-flex>
            </v-layout>

          </v-card>
        </v-flex>

        <v-flex xs12 class="mt-1">
          <v-card class="pb-2">
            <v-card-title>
              <h4>Does saving nickels matter to your bottom line?</h4>
            </v-card-title>
              <v-layout align-baseline>
                <v-flex>
                  <v-slider
                    :step="0.05"
                    :min="0.05"
                    :max="2"
                    always-dirty
                    :thumb-size="24"
                    thumb-label="always"
                    :thumbColor="savingsColor"
                    append-icon="add"
                    prepend-icon="remove"
                    @click:append="slider = slider + .05"
                    @click:prepend="slider = slider - .05"
                    v-model="slider">
                  </v-slider>
                </v-flex>
              </v-layout>
            <v-flex>
              <div class="pa-1 font-italic">
                If you can save <span class="font-weight-bold">{{sliderHint}}</span> per mile ...
              </div>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-1 mt-1">
          <v-card>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="accent" :href="createActionLink">
                <v-icon class="pr-2">message</v-icon>
                Text {{ $t('site-title.brief') }} To Save Nickles
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'SavingsCalculator',
  props: {
    clientId: {
      type: String,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    truckCapacityAnimalCount() {
      return Math.floor(this.truckCapacityPounds / this.weight);
    },
    truckCount() {
      return Math.ceil(this.headsCount / this.truckCapacityAnimalCount);
    },
    annualTruckCount() {
      return this.truckCount * this.selectedFreq;
    },
    effectiveRate() {
      return this.standardRate - this.slider;
    },
    annualTotal() {
      return this.total * this.selectedFreq;
    },
    total() {
      return this.truckCount * this.distance * this.slider;
      // return Math.ceil((this.weight * this.headsCount * this.slider) / this.distance);
    },
    totalByHeads() {
      return this.total / this.headsCount;
    },
    batchFreightSpend() {
      return this.truckCount * this.distance * this.standardRate;
    },
    annualFreightSpend() {
      return this.annualTruckCount * this.distance * this.standardRate;
    },
    sliderHint() {
      return this.$options.filters.currency(this.slider);
    },
    frequencyLabel() {
      if (this.selectedFreq == null) {
        return 'How often do you load out?';
      }
      // return `Frequency (${this.truckCount} trucks)`;
      return 'Shipping Frequency';
    },
    savingsColor() {
      return 'green';
    },
    createActionLink() {
      if (this.isMobile) {
        return this.createSmsLink;
      }

      return this.createSmsLink;
    },
    createSmsLink() {
      const body = `https://bit.ly/LTN-Savings?clientId=${this.identifier || ''}

I want to start (${this.identifier}) saving up to ${this.annualTotal} on my ${this.headsCount} animals, ${this.slider} per mile`;

      const encoded   = window.encodeURIComponent(body);

      const userAgent = navigator.userAgent.toLowerCase();
      const iphone    = userAgent.indexOf('iphone') >= 0;
      const ipad      = userAgent.indexOf('ipad') >= 0;
      const delim     = (iphone || ipad) ? '&' : '?';

      return `sms:3072207800${delim}body=${encoded}`;
      // return `SMSTO:3072207800:I want to save on freight using LTN`;
    },
  },
  watch: {
    total() {
      this.updateDb();
    },
  },
  data() {
    return {
      identifier: null,
      dbRef: null,
      weight: 900,
      data: {},
      loadingBtn: false,
      headsCount: 9500,
      distance: 600,
      slider: 0.25,
      standardRate: 3.75,
      truckCapacityPounds: 50000,
      weightOptions: [
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1400,
        1500,
        1600,
        1700,
        1800,
      ],
      freqOptions: [
        { name: 'Daily', value: 350 },
        { name: 'Weekly', value: 50 },
        { name: 'Monthly', value: 12 },
        { name: 'Yearly', value: 1 },
      ],
      truckCapacityOptions: [
        { name: '48,000 lbs', value: 48000 },
        { name: '49,000 lbs', value: 49000 },
        { name: '50,000 lbs', value: 50000 },
        { name: '52,000 lbs', value: 52000 },
        { name: '55,000 lbs', value: 55000 },
      ],
      selectedFreq: null, // 12,
      // selectedFreq: 12,
    };
  },
  methods: {
    updateDb() {
      const timestamp = (new Date()).getTime();
      firebase.database().ref(`savings/${this.identifier}/${timestamp}`).set({
        frequency: this.selectedFreq,
        slider: this.slider,
        distance: this.distance,
        weight: this.weight,
        headsCount: this.headsCount,
      });
    },
  },
  created() {
    const localStorageIdentifier = localStorage.getItem('ltn_savings_id');
    if (this.clientId) {
      this.identifier = this.clientId;
    } else if (localStorageIdentifier) {
      this.identifier = localStorageIdentifier;
    } else {
      this.identifier = Math.random().toString(32);
      localStorage.setItem('ltn_savings_id', this.identifier);
    }
  },
};
</script>

<style lang="css" scoped>
  .pull-right {
    float: right;
  }


</style>



// WEBPACK FOOTER //
// src/pages/SavingsCalculator.vue